import * as React from 'react';

type HoverState = {
    isHovering?: boolean;
};

export type InjectedHoverProps = HoverState;

export const withHover = <P extends InjectedHoverProps>(InnerComponent: React.ComponentType<P>) => {
    return class extends React.Component<P, HoverState> {
        constructor(props: P) {
            super(props);
            this.handleMouseEnter = this.handleMouseEnter.bind(this);
            this.handleMouseLeave = this.handleMouseLeave.bind(this);

            this.state = {
                isHovering: props.isHovering
            };
        }

        handleMouseEnter() {
            if (!this.state.isHovering) {
                this.setState({isHovering: true});
            }
        }

        handleMouseLeave() {
            if (this.state.isHovering) {
                this.setState({isHovering: false});
            }
        }

        render() {
            return (
                <div
                    style={{width: '100%'}}
                    onMouseEnter={this.handleMouseEnter}
                    onMouseLeave={this.handleMouseLeave}
                >
                    <InnerComponent {...(this.props as P)} {...this.state} />
                </div>
            );
        }
    };
};
